let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4L60i")).then(() => parcelRequire('ei39Q'));